import { jwtDecode } from "jwt-decode";
import { removeAxiosAuth, setAxiosAuth } from "@/utils/api";
import Cookies from "js-cookie";

export const COOKIE_OPTIONS: Cookies.CookieAttributes = { expires: 365, path: "/", sameSite: "Lax" };

export const setToken = (accessToken: string, refreshToken: string): void => {
  Cookies.set("learner-token", accessToken, COOKIE_OPTIONS);
  Cookies.set("learner-refresh-token", refreshToken, COOKIE_OPTIONS);
  setAxiosAuth();
};

export const removeToken = (): void => {
  Cookies.remove("learner-token", { path: "/" });
  Cookies.remove("learner-refresh-token", { path: "/" });
  removeAxiosAuth();
};

/**
 * Verifies if a given token is still valid based on its expiration time.
 *
 * @param {string} token - The token to verify.
 * @returns {boolean} - `true` if the token is still valid, `false` otherwise.
 */
export const verifyToken = (token: string): boolean => {
  try {
    const decoded = jwtDecode<{ exp: number }>(token);
    // Check if the token's expiration time is greater than the current time
    return decoded.exp > new Date().getTime() / 1000;
  } catch (e) {
    // Return false if decoding fails
    return false;
  }
};
